import { useRef } from 'react';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import useScrollMotion from '@/hooks/useScrollMotion';
import ContactForm from './components/ContactForm';

const steps = [
  ['01', 'You tell us the idea, however rough.'],
  ['02', 'A producer reads it and replies personally.'],
  ['03', 'We talk it through and shape what comes next.'],
];

export default function Contact() {
  const root = useRef<HTMLElement>(null);
  useScrollMotion(root);

  return (
    <>
      <title>Contact | Start a Project with FORM &amp; FEEL</title>
      <meta name="description" content="Tell FORM & FEEL about your event idea. A producer reads every inquiry personally and replies to shape what comes next." />
      <Header />
      <main ref={root} className="overflow-x-clip bg-foreground-950 text-background-50">
        <section aria-label="Contact" className="px-4 md:px-6 pt-32 md:pt-40 pb-16 md:pb-20">
          <p className="font-label text-[11px] uppercase tracking-[0.18em] text-background-200" data-reveal="up">Contact / Project inquiry</p>
          <h1 className="mt-6 font-extrabold uppercase tracking-[-0.065em] leading-[0.84] text-[clamp(3rem,11.5vw,12.5rem)]" data-reveal="lines">
            <span className="line-mask"><span className="line-inner">Let&apos;s make</span></span>
            <span className="line-mask"><span className="line-inner">something <span className="text-primary-300">happen.</span></span></span>
          </h1>
          <p className="mt-10 text-sm md:text-base leading-relaxed text-background-100 max-w-[440px]" data-reveal="up">
            Every remarkable experience starts with a conversation. Tell us what you&apos;re imagining.
          </p>
        </section>

        <section aria-label="Inquiry form" className="border-t border-background-50/15 px-4 md:px-6 py-16 md:py-24">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-6">
            <div className="lg:col-span-4">
              <h2 className="text-2xl md:text-3xl font-extrabold tracking-[-0.045em] leading-[0.95]">What happens next</h2>
              <ol className="mt-8 space-y-5">
                {steps.map(([n, t]) => (
                  <li key={n} className="flex gap-4 text-sm text-background-200" data-reveal="up">
                    <span className="font-label text-[11px] text-primary-300 pt-0.5">{n}</span>
                    <span className="max-w-[280px]">{t}</span>
                  </li>
                ))}
              </ol>
            </div>
            <div className="lg:col-span-7 lg:col-start-6">
              <ContactForm />
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}